export const AuthLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-brand">
    <div className="h-10 w-10 rounded-full border-2 border-white/30 border-t-white animate-spin" />
  </div>
)
